export default "__VITE_ASSET__c7eece9a__"